// @core/api/endpoints/calendar/create_recurring_event.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateRecurringEventRequest,
  EventSeriesResponse,
} from '../../../types/calendar';

const BASE_PATH = '/calendar';

/**
 * Create recurring event
 * Creates a recurring event series with a recurrence rule (daily, weekly, monthly, yearly, or custom). Materializes instances within the generation horizon.
 */
export async function CreateRecurringEvent(
  calendar_id: string,
  data: CreateRecurringEventRequest,
  options?: RequestOptions
): Promise<EventSeriesResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/calendars/:calendar_id/events/recurring`;
  requestPath = requestPath.replace(':calendar_id', encodeURIComponent(calendar_id));
  const requestOptions = options;
  return client.post<EventSeriesResponse>(requestPath, data, requestOptions);
}
